import React, {Component} from 'react';

import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Alert
} from 'reactstrap';


import Form from '../../../shared/components/Form';
import TextInput from '../../../shared/components/TextInput';
import Button from '../../../shared/components/Button';

import {
  getInviteLinkForUserToAgency,
  getWelcomeLinkForUser,
  getResetLinkForUser
} from '../../../shared/utils';

class AccountUserEdit extends Component {
  constructor(){
    super();

    this.state = {
      activeRole:'owner',
      error:null
    };
  }

  componentDidMount(){
    if(this.props.needsLoading && !this.props.isCreate){
      this.props.loadUser(this.props.userId)
        .then(() => this.props.loadLinkInfoForUser(this.props.userId))
        .then(() => this.handleLoaded());
    } else if(!this.props.isCreate){
      this.props.loadLinkInfoForUser(this.props.userId)
        .then(() => this.handleLoaded());
    }
  }

  handleLoaded(){
    this.setState({activeRole : this.props.existingUser.isOwner ? 'owner' : 'user'})
  }

  handleSubmit(data){
    if(this.props.isCreate){
      this.props.createUser({
        ...data,
        isOwner:this.state.activeRole === 'owner',
        agencyId:this.props.accountId
      })
        .then(() => this.handleSuccess())
        .catch((err) => this.setState({error:err}));

    } else {
      this.props.updateUser(this.props.userId,{
        ...data,
        isOwner:this.state.activeRole === 'owner'
      })
        .then(() => this.handleSuccess())
        .catch((err) => this.setState({error:err}));
    }
  }

  handleSuccess(){
    const { accountId, history } = this.props;

    history.push(`/superadmin/accounts/${accountId}/users`);
  }

  renderHelp(){
    if(this.state.activeRole === 'owner'){
      return (
        <Alert color='info'>
          Create:&nbsp;<i className='fa fa-thumbs-o-up' aria-hidden='true'></i><br />
          Export:&nbsp;&nbsp;<i className='fa fa-thumbs-o-up' aria-hidden='true'></i><br />
          Team:&nbsp;&nbsp;&nbsp;<i className='fa fa-thumbs-o-up' aria-hidden='true'></i><br />
        </Alert>
      );
    } else if(this.state.activeRole === 'user'){
      return (
        <Alert color='info'>
          Create:&nbsp;<i className='fa fa-thumbs-o-up' aria-hidden='true'></i><br />
          Export:&nbsp;&nbsp;<i className='fa fa-thumbs-o-down' aria-hidden='true'></i><br />
          Team:&nbsp;&nbsp;&nbsp;<i className='fa fa-thumbs-o-down' aria-hidden='true'></i><br />
        </Alert>
      );
    } else {
      return (
        <Alert color='info'>
          Create:;&nbsp;<i className='fa fa-hand-spock-o' aria-hidden='true'></i><br />
          Export:&nbsp;&nbsp;<i className='fa fa-hand-spock-o' aria-hidden='true'></i><br />
          Admin:&nbsp;&nbsp;&nbsp;<i className='fa fa-hand-spock-o' aria-hidden='true'></i><br />
        </Alert>
      );
    }
  }

  render(){
    const { accountId, isCreate,existingUser, needsLoading, existingAccount } = this.props,
      formReady = isCreate || (!needsLoading && !!existingUser);

    return (
      <div>
        <Row>
          <Col xs='12'>
            <Button
              linkHref={`/superadmin/accounts/${accountId}/users`}
              textColor='black'
              backgroundColor='transparent'
            >
              <i className='fa fa-long-arrow-left' aria-hidden='true'></i>
              &nbsp;&nbsp;Back to All Users
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs='12' md='6'>
            {formReady ? (
              <Form onSubmit={(data) => this.handleSubmit(data)}>
                <Row>
                  <Col xs='6'>
                    <br />
                    <FormGroup>
                      <Label>Role</Label>
                      <Input
                        type='select'
                        defaultValue={(isCreate || existingUser.isOwner) ? 'owner' : 'user'}
                        onChange={(e) => this.setState({activeRole:e.target.value})}
                      >
                        <option value='owner'>Admin</option>
                        <option value='user'>Creator</option>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col xs='6'>
                    <br />
                    {this.renderHelp()}
                  </Col>
                </Row>
                <Row>
                  <Col xs='6'>
                    <FormGroup>
                      <Label>First Name</Label>
                      <Input
                        name='firstName'
                        type='text'
                        placeholder='john'
                        defaultValue={isCreate ? '' :existingUser.firstName}
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col xs='6'>
                    <FormGroup>
                      <Label>Last Name</Label>
                      <Input
                        name='lastName'
                        type='text'
                        placeholder='doe'
                        defaultValue={isCreate ? '' :existingUser.lastName}
                        required
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <FormGroup>
                  <Label>Email</Label>
                  <Input
                    name='email'
                    type='email'
                    placeholder='john@doe.com'
                    defaultValue={isCreate ? '' :existingUser.email}
                    required
                  />
                </FormGroup>
                {existingUser && existingUser.emailVerificationToken && (
                  <div>
                    <TextInput 
                      label='Welcome Link'
                      readOnly 
                      copyPaste
                      value={getWelcomeLinkForUser(existingUser)}                      
                    />
                    <TextInput 
                      label='Account Invite Link'
                      readOnly
                      copyPaste
                      value={getInviteLinkForUserToAgency(existingUser,existingAccount)} 
                    />
                    <TextInput 
                      label='Reset Password Link'
                      readOnly 
                      copyPaste
                      value={getResetLinkForUser(existingUser)}
                    />
                  </div>
                )}
                <Button isSubmit>
                  {isCreate ? 'Invite User':'Update User'}
                </Button>
              </Form>
            ) : (
              <div>Loading...</div>
            )}
            <br />
            <br />
          </Col>
        </Row>
      </div>
    )
  }
}


AccountUserEdit.defaultProps = {
  isCreate:false
};

export default AccountUserEdit;



// WEBPACK FOOTER //
// ./src/routes/AccountUserEdit/components/AccountUserEdit.js